import { useEffect, useRef } from 'react';
import { api } from '../services/api';

// זמן ניתוק אוטומטי - 2 שעות (במילישניות)
const AUTO_LOGOUT_TIME = 2 * 60 * 60 * 1000; // 2 שעות

export function useAutoLogout(onLogout, isAuthenticated) {
  const timeoutRef = useRef(null);
  const lastActivityRef = useRef(Date.now());

  useEffect(() => {
    if (!isAuthenticated) {
      // אם המשתמש לא מחובר - נקה את ה-timeout
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
      return;
    }

    // פונקציה לעדכון זמן הפעילות האחרונה
    const updateActivity = () => {
      lastActivityRef.current = Date.now();
      
      // נקה את ה-timeout הקודם
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      
      // הגדר timeout חדש
      timeoutRef.current = setTimeout(() => {
        // ניתוק אוטומטי
        api.logout();
        if (onLogout) {
          onLogout();
        }
        // הצג הודעה למשתמש
        const message = 'ההתחברות פגה עקב חוסר פעילות של שעתיים. אנא התחבר שוב.';
        alert(message);
        // אפשר גם לעדכן את ה-URL אם צריך
        window.location.href = '/';
      }, AUTO_LOGOUT_TIME);
    };

    // אירועים שמעידים על פעילות
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
    
    // הוסף listeners לכל האירועים
    events.forEach(event => {
      document.addEventListener(event, updateActivity, true);
    });

    // התחל את ה-timeout הראשוני
    updateActivity();

    // נקה listeners כשה-component unmount
    return () => {
      events.forEach(event => {
        document.removeEventListener(event, updateActivity, true);
      });
      
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [isAuthenticated, onLogout]);
}
